import React from 'react';
import { CHAT_HANDOFF_FAILURE_MESSAGE, CHAT_HANDOFF_SUCCESS } from '../consts';
import { useAppDispatch } from 'hooks';
import { useUpdateConversation } from '../hooks';
import { resetLiveChatState, setLiveChatStatus } from 'reducers/live-chat';
import { sendTrackingEvent, setWidgetMode } from 'actions/workflows/workflows';
import { deleteForethoughtLiveChat } from 'actions/live-chat';
import { HandoffIntegrations } from 'api/types';

export const useLiveChatFailure = () => {
  const dispatch = useAppDispatch();
  const updateConversation = useUpdateConversation();

  const handleLiveChatFailure = React.useCallback(
    ({
      error,
      integration,
    }: {
      error: string;
      integration: HandoffIntegrations;
    }) => {
      dispatch(
        sendTrackingEvent({
          error: error,
          event_type: 'widget-customer-handoff',
          integration: integration,
          question: '',
          success: false,
        }),
      );
      dispatch(setLiveChatStatus('failure'));
      dispatch(setWidgetMode('workflow'));
      updateConversation({
        [CHAT_HANDOFF_FAILURE_MESSAGE]: error,
        [CHAT_HANDOFF_SUCCESS]: false,
      });
      dispatch(deleteForethoughtLiveChat());
      dispatch(resetLiveChatState());
    },
    [dispatch, updateConversation],
  );

  return handleLiveChatFailure;
};
